"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.nordomatic = void 0;
const extendTheme_1 = require("../extendTheme");
const insights_1 = require("../insights");
const logo = require('./nordomatic.png');
exports.nordomatic = extendTheme_1.extendTheme(insights_1.theme, {
    name: 'nordomatic',
    userFriendlyName: 'Nordomatic',
    colors: {
        primary: '#fff',
        primaryText: '#000',
        primaryDark: '#ddd',
        muted: '#eee',
        success: '#87c144',
        info: 'rgb(70, 120, 200)',
        warning: '#daa520',
        online: '#87c144',
        accent: '#2aaeee',
        accentBackgroundedText: '#FFF',
        pageBackground: '#f6f6f6',
        pageText: '#000',
        cardBackground: '#fff',
        cardText: '#000',
        selected: '#2aaeee',
        charts: {
            primary: '#4abfff',
            min: '#a1e0f8',
            neutral: '#2aaeee',
            max: '#d92121',
            intervalShade: '#ddd',
        },
    },
    logo,
    dark: false,
});
//# sourceMappingURL=index.js.map